// import React, { Component } from "react";
// import Dialog from "@mui/material/Dialog";
// import DialogTitle from "@mui/material/DialogTitle";
// import DialogContent from "@mui/material/DialogContent";
// // import * as firebase from "firebase/app";
//
// class InAppNotification extends Component {
// 	state = {
// 		open: false,
// 		inAppNotificationData: [],
// 	};
// 	audio = new Audio("/assets/audio/customer-notification.mp3");
//
// 	componentDidMount() {
// 		// if (firebase.messaging.isSupported()) {
// 		// 	navigator.serviceWorker.addEventListener("message", (message) => {
// 		// 		console.log(message.data["firebase-messaging-msg-data"]);
// 		// 		if (message.data["firebase-messaging-msg-data"] && message.data["firebase-messaging-msg-data"].data) {
// 		// 			this.audio.play();
// 		// 			if ("vibrate" in navigator) {
// 		// 				console.log("Vibrating");
// 		// 				navigator.vibrate(["100", "150", "100", "100", "150", "100"]);
// 		// 			}
// 		// 			this.setState({
// 		// 				open: true,
// 		// 				inAppNotificationData: message.data["firebase-messaging-msg-data"].data,
// 		// 			});
// 		// 		}
// 		// 	});
// 		// }
// 	}
//
// 	handleClose = () => {
// 		this.setState({ open: false });
// 	};
//
// 	render() {
// 		const { inAppNotificationData, open } = this.state;
// 		return (
// 			<React.Fragment>
// 				<Dialog
// 					maxWidth={false}
// 					fullWidth={true}
// 					fullScreen={false}
// 					open={open}
// 					onClose={this.handleClose}
// 					disableBackdropClick={true}
// 				>
// 					<DialogTitle id="responsive-dialog-title">{inAppNotificationData.title}</DialogTitle>
//
// 					<DialogContent dividers>
// 						<p className="mb-2">{inAppNotificationData.message}</p>
//
// 						{inAppNotificationData.image && (
// 							<img
// 								src={inAppNotificationData.image}
// 								className="img-fluid"
// 								alt={inAppNotificationData.title}
// 							/>
// 						)}
//
// 						<div className="inAppNotificationActions mt-3">
// 							<button
// 								className={`btn inANClose ${inAppNotificationData.click_action && "mr-2"}`}
// 								onClick={() => this.setState({ open: false })}
// 							>
// 								{localStorage.getItem("inAppCloseButton")}
// 							</button>
// 							{inAppNotificationData.click_action && (
// 								<a className="btn inANLink" href={inAppNotificationData.click_action}>
// 									{localStorage.getItem("inAppOpenLinkButton")}
// 								</a>
// 							)}
// 						</div>
// 						<div className="alert-notify-bell" style={{ top: "20px", bottom: "auto" }}>
// 							<i className="si si-bell" style={{ color: localStorage.getItem("storeColor") }} />
// 						</div>
// 					</DialogContent>
// 				</Dialog>
// 			</React.Fragment>
// 		);
// 	}
// }
//
// export default InAppNotification;


import React, { Component } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {onForegroundMessage} from "../../../firebase";


class InAppNotification extends Component {
	state = {
		open: false,
		inAppNotificationData: {},
	};
	audio = new Audio("/assets/audio/customer-notification.mp3");

	componentDidMount() {
		// Listen to foreground messages
		onForegroundMessage((payload) => {
			if (payload?.data) {
				// Play audio
				this.audio.play().catch(() => {});

				// Vibrate device if supported
				if ("vibrate" in navigator) {
					navigator.vibrate([100, 150, 100]);
				}

				console.log("payload: ", payload);

				// Show notification dialog
				this.setState({
					open: true,
					inAppNotificationData: payload.data,
				});
			}
		});
	}

	handleClose = () => {
		this.setState({ open: false });
	};

	render() {
		const { inAppNotificationData, open } = this.state;

		return (
			<Dialog
				maxWidth={false}
				fullWidth
				open={open}
				onClose={this.handleClose}
				disableBackdropClick
				PaperProps={{
					style: {
						borderRadius: 12,
						boxShadow: "0 8px 24px rgba(0,0,0,0.3)",
						padding: "16px",
					},
				}}
			>
				<DialogTitle>{inAppNotificationData?.title}</DialogTitle>

				<DialogContent dividers>
					<p className="mb-2">{inAppNotificationData?.message}</p>

					{inAppNotificationData?.image && (
						<img
							src={inAppNotificationData?.image}
							className="img-fluid"
							alt={inAppNotificationData?.title}
							style={{ borderRadius: "8px", maxWidth: "100%" }}
						/>
					)}

					<div className="inAppNotificationActions mt-3">
						<button
							className={`btn inANClose ${inAppNotificationData.click_action ? "mr-2" : ""}`}
							onClick={this.handleClose}
							style={{
								backgroundColor: localStorage.getItem("storeColor"),
								color: "#fff",
								border: "none",
								padding: "8px 16px",
								borderRadius: "6px",
								cursor: "pointer",
							}}
						>
							{localStorage.getItem("inAppCloseButton")}
						</button>

						{inAppNotificationData?.click_action && (
							<a
								className="btn inANLink"
								href={inAppNotificationData?.click_action}
								style={{
									backgroundColor: "#007bff",
									color: "#fff",
									padding: "8px 16px",
									borderRadius: "6px",
									textDecoration: "none",
									cursor: "pointer",
								}}
							>
								{localStorage.getItem("inAppOpenLinkButton")}
							</a>
						)}
					</div>

					<div className="alert-notify-bell" style={{ top: 20, position: "absolute" }}>
						<i className="si si-bell" style={{ color: localStorage.getItem("storeColor") }} />
					</div>
				</DialogContent>
			</Dialog>
		);
	}
}

export default InAppNotification;




// import React, { Component } from "react";
// import Dialog from "@mui/material/Dialog";
// import DialogTitle from "@mui/material/DialogTitle";
// import DialogContent from "@mui/material/DialogContent";
// import {getMessaging, isSupported, onMessage} from "firebase/messaging";
// import {app} from "../../../firebase";
//
//
// class InAppNotification extends Component {
// 	state = {
// 		open: false,
// 		inAppNotificationData: {}
// 	};
//
// 	audio = new Audio("/assets/audio/customer-notification.mp3");
//
// 	componentDidMount() {
// 		isSupported().then((supported) => {
// 			if (!supported) {
// 				console.warn("FCM not supported in this browser");
// 				return;
// 			}
//
// 			// const messaging = getMessaging(app);
//
// 			this.unsubscribe = onMessage(messaging, (payload) => {
// 				console.log("Foreground FCM payload:", payload);
//
// 				const data = payload?.data;
// 				if (!data) return;
//
// 				this.audio.play().catch(() => {});
//
// 				if ("vibrate" in navigator) {
// 					navigator.vibrate([100, 150, 100, 100, 150, 100]);
// 				}
//
// 				this.setState({
// 					open: true,
// 					inAppNotificationData: data
// 				});
// 			});
// 		});
// 	}
//
// 	componentWillUnmount() {
// 		// Clean up listener
// 		if (this.unsubscribe) {
// 			this.unsubscribe();
// 		}
// 	}
//
// 	handleClose = () => {
// 		this.setState({ open: false });
// 	};
//
// 	render() {
// 		const { inAppNotificationData, open } = this.state;
//
// 		return (
// 			<Dialog
// 				maxWidth={false}
// 				fullWidth
// 				open={open}
// 				onClose={this.handleClose}
// 				disableBackdropClick
// 				PaperProps={{
// 					style: {
// 						borderRadius: 12,
// 						boxShadow: "0 8px 24px rgba(0,0,0,0.3)",
// 						padding: "16px",
// 					},
// 				}}
// 			>
// 				<DialogTitle>{inAppNotificationData?.title}</DialogTitle>
//
// 				<DialogContent dividers>
// 					<p className="mb-2">{inAppNotificationData?.message}</p>
//
// 					{inAppNotificationData?.image && (
// 						<img
// 							src={inAppNotificationData?.image}
// 							className="img-fluid"
// 							alt={inAppNotificationData?.title}
// 							style={{ borderRadius: "8px", maxWidth: "100%" }}
// 						/>
// 					)}
//
// 					<div className="inAppNotificationActions mt-3">
// 						<button
// 							className={`btn inANClose ${inAppNotificationData.click_action ? "mr-2" : ""}`}
// 							onClick={this.handleClose}
// 							style={{
// 								backgroundColor: localStorage.getItem("storeColor"),
// 								color: "#fff",
// 								border: "none",
// 								padding: "8px 16px",
// 								borderRadius: "6px",
// 								cursor: "pointer",
// 							}}
// 						>
// 							{localStorage.getItem("inAppCloseButton")}
// 						</button>
//
// 						{inAppNotificationData?.click_action && (
// 							<a
// 								className="btn inANLink"
// 								href={inAppNotificationData?.click_action}
// 								style={{
// 									backgroundColor: "#007bff",
// 									color: "#fff",
// 									padding: "8px 16px",
// 									borderRadius: "6px",
// 									textDecoration: "none",
// 									cursor: "pointer",
// 								}}
// 							>
// 								{localStorage.getItem("inAppOpenLinkButton")}
// 							</a>
// 						)}
// 					</div>
//
// 					<div className="alert-notify-bell" style={{ top: 20, position: "absolute" }}>
// 						<i className="si si-bell" style={{ color: localStorage.getItem("storeColor") }} />
// 					</div>
// 				</DialogContent>
// 			</Dialog>
// 		);
// 	}
// }
//
// export default InAppNotification;
